import {
  useCurrentWorkspace,
  useRoutineFilter,
  useSetRoutineFilter,
} from '@gripp/shared-logic';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { DebouncedTextInput } from '../forms';

export const RoutineSearchInput = () => {
  const { t } = useTranslation();
  const { data: routineFilter } = useRoutineFilter();
  const { mutateAsync: setRoutineFilter } = useSetRoutineFilter();

  const currentWorkspaceId = useCurrentWorkspace();

  const [text, setText] = useState('');
  const hasTyped = useRef(false);

  useEffect(() => {
    if (!text && routineFilter?.keyword) {
      setText(routineFilter.keyword);
    }
  }, [routineFilter?.keyword]);

  const updateSearch = async (term: string) => {
    if (!routineFilter || !hasTyped.current) return;
    routineFilter.workspaceId = currentWorkspaceId;
    routineFilter.keyword = term;
    await setRoutineFilter(routineFilter);
  };

  return (
    routineFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={updateSearch}
        placeholder={t('routine.filter.searchPlaceholder')}
        value={text}
        onBlur={() => null}
        onChangeText={(text) => {
          if (!hasTyped.current) hasTyped.current = true;
          setText(text);
        }}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          text ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => {
                hasTyped.current = true;
                setText('');
              }}
            />
          ) : (
            <View />
          )
        }
        height={44}
        outlineStyle={styles.inputStyle}
        disableInnerStyle={true}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: Colors.white,
    borderColor: Colors.grayDivider,
    borderWidth: 1,
    borderRadius: 8,
  },
});
